import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import { uniqueId } from '../../utils/underscore';
import UIIcon from '../../icon/UIIcon';
import { OptionGroupType } from '../../types/OptionTypes';
export default class UITypeaheadResultsGroup extends Component {
  render() {
    const {
      children,
      group
    } = this.props;
    this._id = this._id || uniqueId('typeahead-results-group-');
    const computedClassName = classNames("small-caps truncate-text private-typeahead-results-group__label", group.dropdownClassName);
    const computedLabel = group.text || String(group.value);
    return /*#__PURE__*/_jsxs("li", {
      className: "private-typeahead-results-group",
      role: "presentation",
      children: [/*#__PURE__*/_jsxs("div", {
        "aria-hidden": true,
        className: computedClassName,
        id: this._id,
        title: group.title || computedLabel,
        children: [group.icon ? /*#__PURE__*/_jsx(UIIcon, {
          name: group.icon
        }) : null, " ", computedLabel]
      }), /*#__PURE__*/_jsx("ul", {
        "aria-labelledby": this._id,
        className: "private-typeahead-results-group__list list-unstyled",
        role: "listbox",
        children: children
      })]
    });
  }

}
UITypeaheadResultsGroup.propTypes = {
  children: PropTypes.node,
  // @ts-expect-error Proptypes for group and option are misaligned with TS
  group: OptionGroupType.isRequired
};
UITypeaheadResultsGroup.displayName = 'UITypeaheadResultsGroup';